// Cross-component plumbing for the break lock.
//
// This module deliberately imports nothing: src/apis/instance.js needs to raise the lock
// without importing the break context (which imports the services, which import the axios
// instance) - keeping the bus dependency free avoids that import cycle.
//
// The break state itself is pushed over SignalR, so there is nothing here for cross-tab sync.

const lockListeners = new Set();
const logoutListeners = new Set();

export const onBreakLock = listener => {
  lockListeners.add(listener);
  return () => lockListeners.delete(listener);
};

export const emitBreakLock = payload => {
  lockListeners.forEach(listener => listener(payload));
};

export const onLogout = listener => {
  logoutListeners.add(listener);
  return () => logoutListeners.delete(listener);
};

export const emitLogout = () => {
  logoutListeners.forEach(listener => listener());
};
